module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.id_name
    },
    on: {
      "click": _vm.generate_excel
    }
  }, [_vm._t("default", function() {
    return [_vm._v("\n    " + _vm._s(_vm.button_text) + _vm._s(_vm.ajaxGetKey) + "\n  ")]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cbe8d7d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jsonExcel.vue
// module id = 1070
// module chunks = 1